import cover from '../helpers/cover';

// Fill image
export function fill(context, image, moveX, moveY, rotate, scale, placeholderFillratio) {
  const { width, height } = context.canvas;
  const canvasAspect = width < height ? 'portrait' : (height === width ? 'square' : 'landscape');

  if (rotate % Math.PI && canvasAspect !== 'square') {
    return cover(image, moveX, moveY, height, width, rotate, placeholderFillratio).render(context);
  }

  return cover(image, moveX, moveY, width, height, rotate, placeholderFillratio).render(context);
}

export function fillObject(context, image, moveX, moveY, rotate, scale, width, height) {
  const { width: canvasWidth, height: canvasHeight } = context.canvas || context;
  const {
    bounds,
    sw,
    sh,
  } = rotate % Math.PI ? cover(image, moveX, moveY, canvasHeight, canvasWidth, rotate) : cover(image, moveX, moveY, canvasWidth, canvasHeight, rotate);


  return {
    x: moveX,
    y: moveY,
    bounds,
    sw,
    sh,
    scale,
    width,
    height,
  };
}

// Fit image
export function fit(context, image, angle) {
  const canvasHeight = context.canvas.height;
  const canvasWidth = context.canvas.width;
  const imageWidth = image.width;
  const imageHeight = image.height;

  const isRotated = angle === 1.5707963267948966 || angle === 4.71238898038469;

  const hRatio = isRotated ? canvasWidth / imageHeight : canvasWidth / imageWidth;
  const vRatio = isRotated ? canvasHeight / imageWidth : canvasHeight / imageHeight;
  const ratio = isRotated ? Math.max(hRatio, vRatio) : Math.min(hRatio, vRatio);

  if (isRotated) {
    return context.drawImage(
      image, 0, 0,
      imageWidth,
      imageHeight,
      (canvasWidth / 2) - ((imageWidth * ratio) / 2),
      (canvasHeight / 2) - ((imageHeight * ratio) / 2),
      imageWidth * ratio,
      imageHeight * ratio,
    );
  }

  return context.drawImage(
    image, 0, 0,
    imageWidth, imageHeight,
    (canvasWidth / 2) - ((imageWidth * ratio) / 2),
    (canvasHeight / 2) - ((imageHeight * ratio) / 2),
    imageWidth * ratio,
    imageHeight * ratio,
  );
}

export function maximumDrag(rotate, originalImageHeight, originalImageWidth, fillsizes, placeholderHeight, placeholderWidth, imageRatio) {
  let moves = {};

  if (rotate === 1.5707963267948966 || rotate === 4.71238898038469) {
    moves = {
      moveX: ((fillsizes.width - placeholderWidth) / (fillsizes.width / originalImageHeight)),
      moveY: ((fillsizes.height - placeholderHeight) / (fillsizes.width / originalImageHeight)),
    };
  } else {
    moves = {
      moveX: ((fillsizes.width - placeholderWidth) / imageRatio),
      moveY: ((fillsizes.height - placeholderHeight) / imageRatio),
    };
  }


  return moves;
}



// WEBPACK FOOTER //
// ./src/redux/helpers/canvas.js